// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import { hasRestrictedCartLines, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { parseBoolean } from "@steiner/XDL/Utilities";

export const isBidItem = (cartLine: CartLineModel | undefined) =>
    parseBoolean(cartLine?.properties?.isBidItem);

// xng-change - STR-2674 - Show the invalid price for bid products
export const xHasProductsWithInvalidPrice = (cart: Cart | undefined) =>
    cart?.cartLines?.some(
        cartLine =>
            !cartLine.isPromotionItem &&
            !cartLine.quoteRequired &&
            !cartLine.allowZeroPricing &&
            cartLine.pricing?.unitNetPrice === 0 &&
            cartLine.pricing?.unitRegularPrice === 0 &&
            !isBidItem(cartLine),
    );

// xng-change - STR-2674 - Allow checkout for zero price bid products
export const xIsCartCheckoutDisabled = (cart: Cart | undefined) =>
    cart &&
    ((!cart.canCheckOut && !cart.canRequisition) ||
        isCartEmpty(cart) ||
        hasRestrictedCartLines(cart) ||
        xHasProductsWithInvalidPrice(cart));